export default __webpack_public_path__ + "static/media/star-icon.41b0445b.svg";